import { render, staticRenderFns } from "./cargoWarehousingList.vue?vue&type=template&id=7b24ba2d&scoped=true"
import script from "./cargoWarehousingList.vue?vue&type=script&lang=js"
export * from "./cargoWarehousingList.vue?vue&type=script&lang=js"
import style0 from "./cargoWarehousingList.vue?vue&type=style&index=0&id=7b24ba2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b24ba2d",
  null
  
)

export default component.exports